// Builds the Domain > Goal > Target > Skill tree from the flat list the server returns.
// Only leaves (rows with no children) get rated.

const bySortOrder = (a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0);

export function buildTree(standards) {
    const childrenByParent = {};
    standards.forEach((s) => {
        if (s.parentId) {
            childrenByParent[s.parentId] = childrenByParent[s.parentId] || [];
            childrenByParent[s.parentId].push(s);
        }
    });

    const attachChildren = (node) => ({
        ...node,
        children: (childrenByParent[node.id] || []).sort(bySortOrder).map(attachChildren)
    });

    const goals = standards
        .filter((s) => !s.parentId)
        .sort(bySortOrder)
        .map(attachChildren);

    const domains = [];
    const domainIndex = {};
    goals.forEach((goal) => {
        const name = goal.domain || 'Goals';
        if (domainIndex[name] === undefined) {
            domainIndex[name] = domains.length;
            domains.push({ name, goals: [] });
        }
        domains[domainIndex[name]].goals.push(goal);
    });

    return domains;
}

export function leavesOf(nodes) {
    return nodes.flatMap((n) => (n.children && n.children.length ? leavesOf(n.children) : [n]));
}
